import type { ReactNode } from 'react';
import { FontWeights } from '@newcore/ui/enums/font-weights';
import { TextSizes } from '@newcore/ui/enums/typography-text-sizes';
import { Text } from '@newcore/ui/typography';

interface InstallStepProps {
  number: number;
  children: ReactNode;
}

export function InstallStep({ number, children }: InstallStepProps) {
  return (
    <li className='flex items-start gap-3.5'>
      <Text
        as='span'
        size={TextSizes.XS}
        weight={FontWeights.SEMIBOLD}
        className='flex size-[26px] shrink-0 items-center justify-center rounded-full bg-ink-800 text-surface-50'
      >
        {number}
      </Text>
      <div className='flex min-w-0 flex-col items-start gap-3'>
        <Text
          as='span'
          size={TextSizes.MD}
          className='font-inter leading-[1.35] tracking-[-0.16px] text-ink-800'
        >
          {children}
        </Text>
      </div>
    </li>
  );
}
